<template>
    <answers ref="answers"
             code_question_group="GQ05"
             danger_code="MCAL27"
             @ready="setAnswers({question_group: question_groups[0]})"
    >
        <template slot="QCAL064"
                  slot-scope="data"
        >
            {{ data.data.question }}
            <div v-if="show_components_iarc[0].length > 0"
                 class="font-weight-bold  mt-2"
            >
                <span class="font-weight-bold text-primary"> Componentes</span>
                <div v-for="c in show_components_iarc[0]">
                    {{ c.cas_number }} - {{ c.name }}
                    <b-badge variant="warning">
                        {{ c.final_percentage }}%
                    </b-badge>
                </div>
            </div>
        </template>

        <template slot="QCAL066"
                  slot-scope="data"
        >
            {{ data.data.question }}
            <div v-if="show_components_iarc[1].length > 0"
                 class="font-weight-bold mt-2"
            >
                <span class="font-weight-bold text-primary"> Componentes</span>
                <div v-for="c in show_components_iarc[1]">
                    {{ c.cas_number }} - {{ c.name }}
                    <b-badge variant="warning">
                        {{ c.final_percentage }}%
                    </b-badge>
                </div>
            </div>
        </template>
    </answers>
</template>

<script>
import {mapMutations, mapState} from 'vuex';
import answers from '../../../components/answers.vue';

export default {
    name: 'index',
    data() {
        return {
            show_components_iarc: [[], []]
        };
    },
    components: {
        answers
    },
    computed: {
        ...mapState('calculator', [
            'question_groups',
            'components_iarc',
            'product',
            'grouped_components',
            'questions_index',
            'question_groups'
        ])
    },
    methods: {
        ...mapMutations('calculator', ['setQuestionsIndex']),
        setAnswers({question_group}) {
            this.show_components_iarc = [[], []];

            let c1 = 0;
            let c2a = 0;

            this.grouped_components.map(c => {
                const component = this.components_iarc.find(ciarc => ciarc.cas_number === c.cas_number);

                if (component
                    && !c.omit_in_carcinogens
                    && component.field_values
                    && component.field_values.Grupo) {
                    const group = component.field_values.Grupo;

                    switch (group.list.toLowerCase()) {
                        case '1':
                            this.show_components_iarc[0].push(c);
                            c1 += c.final_percentage;
                            break;
                        case '2a':
                            this.show_components_iarc[1].push(c);
                            c2a += c.final_percentage;
                            break;
                    }
                }
            });

            let questions = question_group.questions;

            if ((c1 || c2a) && this.questions_index > 0) {
                this.setQuestionsIndex(0);
                questions = this.question_groups[0].questions
            }

            if (c1 >= 0.1) {
                let question = questions.find(q => q.code === 'QCAL064');

                if (question) {
                    question.answer = true;

                    this.$refs.answers.classify(question.danger_class.code, question.category, question.sga_categories, question.sub_category);
                }
            }

            if (c2a >= 0.1) {
                let question = questions.find(q => q.code === 'QCAL066');

                if (question) {
                    question.answer = true;
                    this.$refs.answers.classify(question.danger_class.code, question.category, question.sga_categories, question.sub_category);
                }
            }
        }
    }
};
</script>
